import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Breadcrumb,
  Button,
  Container,
  Row,
  Col,
  Table,
  Spinner,
  Form,
  FloatingLabel,
} from "react-bootstrap";

import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import BaseAPI from "../../../api/BaseAPI";
import NextAndPreviousPageAPI from "../../../api/NextAndPreviousPageAPI";
import ModalLancamentoNegocio from "../components/ModalLancamentoNegocio";
import ModalEditarnegocio from "../components/ModalEditarNegocio";
import ModalExcluirNegocio from "../components/ModalExcluirNegocio";
import ModalTarefas from "../components/ModalTarefas";
import RenderIf from "../../../design_system/RenderIf";

function ListaNegocios() {
  const [negocios, setNegocios] = useState([{}]);
  const [carregando, setCarregando] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [novoNegocio, setNovoNegocio] = useState({});
  const [valorTotalNegocios, setValorTotalNegocios] = useState(0)
  const [qtdNegocios, setQtdNegocios] = useState(0);

  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      query: "",
    },
  });

  const getFirstDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split("T")[0];
  };

  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const getValorNegocios = (values) => {
    setCarregando(true);
    BaseAPI.get("/negocios/valor_total_negocios/", {
      params: {
        cliente_nome: values ? values.cliente_nome : null,
        responsavel: values ? values.responsavel : null,
        parceiro: values ? values.parceiro : null,
        data_inicial: values ? values.data_inicial : getFirstDayOfMonth(),
        data_final: values ? values.data_final : getCurrentDate(),
      },
    })
    .then((response) => {
      setCarregando(false)
      const { data } = response;
      setValorTotalNegocios(data.valor_total_negocios)
    })
     .catch((err) => {
        alert(err);
      });
  }

  const getNegocios = (values) => {
    setCarregando(true);
    BaseAPI.get("/negocios/lista_negocios/", {
      params: {
        cliente_nome: values ? values.cliente_nome : null,
        responsavel: values ? values.responsavel : null,
        parceiro: values ? values.parceiro : null,
        data_inicial: values ? values.data_inicial : getFirstDayOfMonth(),
        data_final: values ? values.data_final : getCurrentDate(),
      },
    })
      .then((response) => {

        setCarregando(false);
        const { data } = response;
        setNegocios(data);
      })
      .catch((err) => {
        alert(err);
      });

      BaseAPI.get("util/total_tabela/", {
        params: {model: "negocios"}
      })
      .then((response) => {
        const { data } = response;
         setQtdNegocios(data.total)
      })
      .catch((err) => {
        alert(err);
      });

      BaseAPI.get("/negocios/valor_total_negocios/", {
        params: {
          cliente_nome: values ? values.cliente_nome : null,
          responsavel: values ? values.responsavel : null,
          parceiro: values ? values.parceiro : null,
          data_inicial: values ? values.data_inicial : getFirstDayOfMonth(),
          data_final: values ? values.data_final : getCurrentDate(),
        },
      })
      .then((response) => {
        setCarregando(false)
        const { data } = response;
        setValorTotalNegocios(data.valor_total_negocios)
      })
       .catch((err) => {
          alert(err);
        });
  };

  function formatDateTime(dateTimeStr) {
    const date = new Date(dateTimeStr);
    const day = String(date.getDate() + 1);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const nextPage = () => {
    const url = new URL(negocios.next);
    const path = url.pathname.substring(7) + url.search;
    NextAndPreviousPageAPI.get(path)
      .then((response) => {
        const { data } = response;
        setNegocios(data);
        setCarregando(false);
      })
      .catch((err) => {
        alert(err);
      });
  };
  const previousPage = () => {
    const url = new URL(negocios.previous);
    const path = url.pathname.substring(7) + url.search;
    NextAndPreviousPageAPI.get(path)
      .then((response) => {
        const { data } = response;
        setNegocios(data);
        setCarregando(false);
      })
      .catch((err) => {
        alert(err);
      });
  };

  useEffect(() => {
    setValue("data_inicial", getFirstDayOfMonth());
    setValue("data_final", getCurrentDate());
    getNegocios();
    getValorNegocios();
  }, []);

  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Negócios</Breadcrumb.Item>
      </Breadcrumb>
      <form onSubmit={handleSubmit(getNegocios)}>
        <Row className="my-4">
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              label="Nome do cliente"
              className="mb-3"
            >
              <Form.Control type="text" {...register("cliente_nome")} />
            </FloatingLabel>
          </Col>
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              label="Nome do responsável"
              className="mb-3"
            >
              <Form.Control type="text" {...register("responsavel")} />
            </FloatingLabel>
          </Col>
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              label="Nome do parceiro"
              className="mb-3"
            >
              <Form.Control type="text" {...register("parceiro")} />
            </FloatingLabel>
          </Col>
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              label="Data inicial"
              className="mb-3"
            >
              <Form.Control type="date" {...register("data_inicial")} />
            </FloatingLabel>
          </Col>
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              label="Data final"
              className="mb-3"
            >
              <Form.Control type="date" {...register("data_final")} />
            </FloatingLabel>
          </Col>
          <Col sm className="mt-2">
            <ModalTarefas
              showModal={showModal}
              key={showModal}
              novoNegocio={novoNegocio}
            />
            <Button className="mx-1">
              <ManageSearchIcon onClick={handleSubmit(getNegocios)} />
            </Button>
            <ModalLancamentoNegocio
              getNegocios={getNegocios}
              lancarTarefas={(lancar) => {
                setShowModal(lancar);
              }}
              novoNegocio={(novoNegocio) => setNovoNegocio(novoNegocio)}
            />
          </Col>
        </Row>
      </form>
      <div className="text-end">
        Valor total de negócios: R${valorTotalNegocios.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
      </div>
      Total Negócios: {qtdNegocios}
      <Table striped responsive bordered>
        <thead className="text-center">
          <tr>
            <th>Data</th>
            <th>Título</th>
            <th>Cliente</th>
            <th>Valor</th>
            <th>Responsável</th>
            <th>Situação</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {carregando && <Spinner animation="border" variant="primary" />}
          {console.log(negocios, valorTotalNegocios)}
          {!carregando &&
            !!negocios.results &&
            negocios.results.length > 0 &&
            negocios.results.map((negocio) => {
              const dataHoraFormatada = formatDateTime(
                negocio.data_hora_negocio
              );
              return (
                <tr key={negocio.id_negocio}>
                  <td>{dataHoraFormatada}</td>
                  <td>{negocio.titulo}</td>
                  <td>{negocio.cliente_nome}</td>
                  <td>R${negocio.valor_negocio}</td>
                  <td>{negocio.responsavel_nome}</td>
                  <td>
                    <div
                      className={
                        "m-auto text-white " +
                        (negocio.situacao === "E"
                          ? "bg-warning"
                          : negocio.situacao === "P"
                          ? "bg-danger"
                          : "bg-success")
                      }
                      title={
                        negocio.situacao === "E"
                          ? "Em Andamento"
                          : negocio.situacao === "P"
                          ? "Perdido"
                          : "Fechado"
                      }
                    >
                      {negocio.situacao == "E"
                        ? "Andamento"
                        : negocio.situacao == "P"
                        ? "Perdido"
                        : "Fechado"}
                    </div>
                  </td>

                  <td>
                    <Row className="justify-content-center mx-1">
                      <Col sm={4}>
                        <ModalEditarnegocio
                          id_negocio={negocio.id_negocio}
                          getNegocios={() => getNegocios()}
                        />{" "}
                      </Col>
                      <Col sm={4}>
                        <ModalExcluirNegocio
                          idNegocio={negocio.id_negocio}
                          getNegocios={() => getNegocios()}
                        />
                      </Col>
                    </Row>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center">
        <RenderIf condicao={negocios.next}>
          <div className="m-1">
            <Button variant="primary" onClick={nextPage}>
              &gt;
            </Button>
          </div>
        </RenderIf>
        <RenderIf condicao={negocios.previous}>
          <div className="m-1">
            <Button variant="primary" onClick={previousPage}>
              &lt;
            </Button>
          </div>
        </RenderIf>
      </div>
    </Container>
  );
}

export { ListaNegocios };
export default ListaNegocios;
